import {DateTime} from 'luxon';
import {connect} from 'react-redux';

import {ChannelModel} from '../../../../../libs/shared/core/src/models/api/channelModel';
import {isTeammateNamespace} from '../../../../../libs/shared/core/src/models/helpers/namespaceHelpers';
import {makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {buildChannelSettingsPath} from '../../../../helpers/models/channelHelpers';
import {PermissionsEnum} from '../../../../models/api/roleModel';
import {getHasPermission} from '../../../../store/data/access/accessSelectors';
import {toggleDismissChannelErrorsAction} from '../../../../store/data/localPreferences/localPreferencesActions';
import {helpCenterUrl, navigateToLinkAction} from '../../../../store/stateless/navigationActions';
import {ChannelErrorBanner} from './channelErrorBanner';

/*
 * Props.
 */

interface ChannelErrorBannerContainerProps {
  channel: ChannelModel;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  hasPermission: getHasPermission,
}));

export const ChannelErrorBannerContainer = connect(
  mapStateToProps,
  {toggleDismissChannelErrorsAction, navigateToLinkAction},
  (stateProps, dispatchProps, ownProps: ChannelErrorBannerContainerProps) => {
    const {channel} = ownProps;

    const canAccessChannelSettings = stateProps.hasPermission(
      channel.namespace,
      PermissionsEnum.INBOX_UPDATE,
    );
    const onOpenSettingsClick = canAccessChannelSettings
      ? () => {
          const settingsPath = buildChannelSettingsPath(channel);
          dispatchProps.navigateToLinkAction(settingsPath);
        }
      : undefined;

    const onLinkClick = () => {
      const {error} = channel;

      // If the provided error has a link, use it.
      if (error && error.linkTarget) {
        dispatchProps.navigateToLinkAction(error.linkTarget);
        return;
      }

      // Otherwise, just open the help center.
      dispatchProps.navigateToLinkAction(helpCenterUrl);
    };

    const onDismissClick = () => {
      // Personal channel errors should only be dimissed for 8 hours
      const expiryDateForPersonalChannel = DateTime.now().plus({hours: 8}).toMillis();
      const expiryDate = isTeammateNamespace(channel.namespace) ? expiryDateForPersonalChannel : undefined;

      dispatchProps.toggleDismissChannelErrorsAction([channel.id], true, expiryDate);
    };

    return {
      ...ownProps,
      onOpenSettingsClick,
      onLinkClick,
      onDismissClick,
    };
  },
)(ChannelErrorBanner);
